<script>
  import { _ } from "$helpers/i18n.js";
  import { Accordion } from "$lib";
  import { globalStore } from "../../store/globalStore.js";

  const isMobile = globalStore.isMobile;

  let activeIndex = null;
  let opens = {};

  function toggle(i) {
    if ($isMobile) {
      activeIndex = activeIndex === i ? null : i;
    } else {
      opens = { ...opens, [i]: !opens[i] };
    }
  }
</script>

<div class="explanation-container">
  <!-- --------- ¿Para qué sirve? ---------  -->
  <Accordion title={$_("explanation.title_1")} open={$isMobile ? activeIndex === 0 : !!opens[0]} onToggle={() => toggle(0)}>
    <div class="explanation-item">
      <p>{$_("cashflowMonthly.explanation.purpose")}</p>
      <ol>
        <li>{$_("cashflowMonthly.explanation.purpose_1")}</li>
        <li>{$_("cashflowMonthly.explanation.purpose_2")}</li>
      </ol>
      
      <p>{$_("cashflowMonthly.explanation.purpose_3")}
         <strong>{$_("common.calculate_bold")}</strong>{$_("cashflowMonthly.explanation.purpose_3.1")}
      </p>
  
      <div class="formula">
        <span class="left">{$_("cashflowMonthly.explanation.form_left_part")}</span>
        <span class="right">{$_("cashflowMonthly.explanation.form_right_part")}</span>
      </div>    
    </div>
    </Accordion>
  
    <!-- --------- Conceptos Importantes ---------  -->
    <Accordion title={$_("explanation.title_2")} open={$isMobile ? activeIndex === 1 : !!opens[1]} onToggle={() => toggle(1)}>
    <div class="explanation-item">
      <ul class="punteo-list">
        <li>
          {$_("explanation.important_concepts_common_2")}
          <strong>{$_("cashflowMonthly.explanation.important_concepts_1_bold")}</strong>
          {$_("cashflowMonthly.explanation.important_concepts_1.1")}
        </li>
        <li>
          {$_("explanation.important_concepts_common_2")}
          <strong>{$_("cashflowMonthly.explanation.important_concepts_2_bold")}</strong>
          {$_("cashflowMonthly.explanation.important_concepts_2.1")}
        </li>
        <li>
          {$_("explanation.important_concepts_common_2")}
          <strong>{$_("cashflowMonthly.explanation.important_concepts_3_bold")}</strong>
          {$_("cashflowMonthly.explanation.important_concepts_3.1")}
        </li>
        <li>
          {$_("cashflowMonthly.explanation.important_concepts_4")}
          <strong>{$_("cashflowMonthly.explanation.important_concepts_4_bold")}</strong>
          {$_("cashflowMonthly.explanation.important_concepts_4.1")}
        </li>
        <li>
          {$_("cashflowMonthly.explanation.common_1")}
          <strong>{$_("cashflowMonthly.explanation.important_concepts_5_bold")}</strong>
          {$_("cashflowMonthly.explanation.important_concepts_5.1")}
        </li>
        <li>
          {$_("cashflowMonthly.explanation.common_1")}
          <strong>{$_("cashflowMonthly.explanation.important_concepts_6_bold")}</strong>
          {$_("cashflowMonthly.explanation.important_concepts_6.1")}
        </li>
        <li>
          {$_("cashflowMonthly.explanation.common_1")}
          <strong>{$_("cashflowMonthly.explanation.important_concepts_7_bold")}</strong>
          {$_("cashflowMonthly.explanation.important_concepts_7.1")}
        </li>
        <li>
          {$_("cashflowMonthly.explanation.common_1")}
          <strong>{$_("cashflowMonthly.explanation.important_concepts_8_bold")}</strong>
          {$_("cashflowMonthly.explanation.important_concepts_8.1")}
        </li>
        <li>
          {$_("cashflowMonthly.explanation.common_1")}
          <strong>{$_("cashflowMonthly.explanation.important_concepts_9_bold")}</strong>
          {$_("cashflowMonthly.explanation.important_concepts_9.1")}
        </li>
        <li>
          {$_("cashflowMonthly.explanation.important_concepts_10")}
          <strong>{$_("cashflowMonthly.explanation.important_concepts_10_bold")}</strong>
          {$_("cashflowMonthly.explanation.important_concepts_10.1")}
        </li>
        <li>
          {$_("cashflowMonthly.explanation.common_1")}
          <strong>{$_("cashflowMonthly.explanation.important_concepts_11_bold")}</strong>
          {$_("cashflowMonthly.explanation.important_concepts_11.1")}
        </li>
        <li>
          {$_("cashflowMonthly.explanation.important_concepts_12")}
          <strong>{$_("cashflowMonthly.explanation.important_concepts_12_bold")}</strong>
          {$_("cashflowMonthly.explanation.important_concepts_12.1")}
        </li>
        <li>
          {$_("cashflowMonthly.explanation.important_concepts_13")}
          <strong>{$_("cashflowMonthly.explanation.important_concepts_13_bold")}</strong>
          {$_("cashflowMonthly.explanation.important_concepts_13.1")}
        </li>
        <li>
          {$_("cashflowMonthly.explanation.common_1")}
          <strong>{$_("cashflowMonthly.explanation.important_concepts_14_bold")}</strong>
          {$_("cashflowMonthly.explanation.important_concepts_14.1")}
        </li>
        <li>
          {$_("cashflowMonthly.explanation.common_1")}
          <strong>{$_("cashflowMonthly.explanation.important_concepts_15_bold")}</strong>
          {$_("cashflowMonthly.explanation.important_concepts_15.1")}
        </li>
        <li>
          {$_("cashflowMonthly.explanation.common_1")}
          <strong>{$_("cashflowMonthly.explanation.important_concepts_16_bold")}</strong>
          {$_("cashflowMonthly.explanation.important_concepts_16.1")}
        </li>
      </ul>
    </div>
  </Accordion>

  <!-- --------- Factores a considerar ---------  -->
  <Accordion title={$_("explanation.title_3")} open={$isMobile ? activeIndex === 2 : !!opens[2]} onToggle={() => toggle(2)}>
  <div class="explanation-item">
    <p>{$_("cashflowMonthly.explanation.factors_consider_1")}</p>
    <ul class="punteo-list">
      <li>{$_("cashflowMonthly.explanation.factors_consider_2")}</li>
      <li>{$_("cashflowMonthly.explanation.factors_consider_3")}</li>
      <li>{$_("cashflowMonthly.explanation.factors_consider_4")}</li>
    </ul>
  </div>
  </Accordion>

  <!-- --------- Casos prácticos ---------  -->
  <Accordion title={$_("explanation.title_8")} open={$isMobile ? activeIndex === 3 : !!opens[3]} onToggle={() => toggle(3)}>
  <div class="explanation-item">
    <ol class="punteo-list">
      <!-- Saldo Inicial Mensual -->
      <li>
        <strong>{$_("cashflowMonthly.explanation.practical_case_1_bold")}</strong>
        {$_("cashflowMonthly.explanation.practical_case_1")}
      </li>
      <!-- Ingresos Mensuales -->
      <li>
        <strong>{$_("cashflowMonthly.explanation.practical_case_2_bold")}</strong>
        <ul>
          <li>
            <strong>{$_("cashflowMonthly.explanation.practical_case_2.1_bold")}</strong>
            {$_("cashflowMonthly.explanation.practical_case_2.1")}
            <strong>{$_("cashflowMonthly.explanation.practical_case_2.1.1_bold")}</strong>{$_("common.full_stop")}
          </li>
          <li>
            <strong>{$_("cashflowMonthly.explanation.practical_case_2.2_bold")}</strong>
            {$_("cashflowMonthly.explanation.practical_case_2.2")}
            <strong>{$_("cashflowMonthly.explanation.practical_case_2.2.1_bold")}</strong>{$_("common.full_stop")}
          </li>
          <li>
            <strong>{$_("cashflowMonthly.explanation.practical_case_2.3_bold")}</strong>
            {$_("cashflowMonthly.explanation.practical_case_2.3")}
            <strong>{$_("cashflowMonthly.explanation.practical_case_2.3.1_bold")}</strong>
            {$_("cashflowMonthly.explanation.practical_case_2.3.2")}
          </li>
        </ul>
      </li>
      <!-- Egresos Mensuales (Gastos totales) -->
      <li>
        <strong>{$_("cashflowMonthly.explanation.practical_case_3_bold")}</strong>
      </li>
      <ul>    
        <li>
          <strong>{$_("cashflowMonthly.explanation.practical_case_3.2_bold")}</strong>
          {$_("cashflowMonthly.explanation.practical_case_3.2")}
          <strong>{$_("cashflowMonthly.explanation.practical_case_3.2.1_bold")}</strong>
          {$_("cashflowMonthly.explanation.practical_case_3.2.2")}
        </li>
        <li>
          <strong>{$_("cashflowMonthly.explanation.practical_case_3.1_bold")}</strong>
          {$_("cashflowMonthly.explanation.practical_case_3.1")}
          <strong>{$_("cashflowMonthly.explanation.practical_case_3.1.1_bold")}</strong>{$_("common.full_stop")}
        </li>
        <li>
          <strong>{$_("cashflowMonthly.explanation.practical_case_3.3_bold")}</strong>
          {$_("cashflowMonthly.explanation.practical_case_3.3")}
          <strong>{$_("cashflowMonthly.explanation.practical_case_3.3.1_bold")}</strong>{$_("common.full_stop")}
        </li>
        <li>
          <strong>{$_("cashflowMonthly.explanation.practical_case_3.4_bold")}</strong>
          {$_("cashflowMonthly.explanation.practical_case_3.4")}
          <strong>{$_("cashflowMonthly.explanation.practical_case_3.4.1_bold")}</strong>{$_("common.full_stop")}
        </li>
        <li>
          <strong>{$_("cashflowMonthly.explanation.practical_case_3.5_bold")}</strong>
          {$_("cashflowMonthly.explanation.practical_case_3.5")}
          <strong>{$_("cashflowMonthly.explanation.practical_case_3.5.1_bold")}</strong>{$_("common.full_stop")}
        </li>
      </ul>
    </ol>
      <p>
        <strong>{$_("cashflowMonthly.explanation.practical_case_4_bold")}</strong>
        <br/>
        {$_("cashflowMonthly.explanation.practical_case_4")}
        <strong>{$_("cashflowMonthly.explanation.practical_case_4.1_bold")}</strong>
      </p>

      <p>
        <strong>{$_("cashflowMonthly.explanation.practical_case_5_bold")}</strong>
        <br/>
        {$_("cashflowMonthly.explanation.practical_case_5")}
        <strong>{$_("cashflowMonthly.explanation.practical_case_4.1_bold")}</strong>{$_("common.full_stop")}
      </p>
      <ul>
        <li>
          <strong>{$_("cashflowMonthly.explanation.practical_case_5.2_bold")}</strong>
          {$_("cashflowMonthly.explanation.practical_case_5.2")}
        </li>
        <li>
          <strong>{$_("cashflowMonthly.explanation.practical_case_5.3_bold")}</strong>
          {$_("cashflowMonthly.explanation.practical_case_5.3")}
        </li>
        <li>
          <strong>{$_("cashflowMonthly.explanation.practical_case_5.4_bold")}</strong>
          {$_("cashflowMonthly.explanation.practical_case_5.4")}
        </li>
      </ul>
    <p>
      <strong>{$_("cashflowMonthly.explanation.practical_case_6_bold")}</strong>
      {$_("cashflowMonthly.explanation.practical_case_6")}
      <strong>{$_("cashflowMonthly.explanation.practical_case_6.1_bold")}</strong>
      {$_("cashflowMonthly.explanation.practical_case_6.2")}
      <strong>{$_("cashflowMonthly.explanation.practical_case_6.3_bold")}</strong>
      {$_("cashflowMonthly.explanation.practical_case_6.4")}
    </p>
  </div>
  </Accordion>
</div>
